var P = Object.defineProperty;
var F = (l, e, t) => e in l ? P(l, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : l[e] = t;
var o = (l, e, t) => F(l, typeof e != "symbol" ? e + "" : e, t);
import { g as h } from "../../index-DwB8CbmG.js";
import { g as f } from "../../get-6ZYTVrGy.js";
import { s as p } from "../../set-BNuXIoqy.js";
import { stepParamsFieldLogicLanguageOptionsResolver as O } from "./step-params-field-logic-language-options-resolver.js";
import { o as b } from "../../omit-BQ2BPUFJ.js";
import { F as c } from "../../index-gVtEopq1.js";
import { StringFieldComponentEnum as L } from "../../app/field/types/string.js";
class T {
  constructor() {
    o(this, "schema", {});
    o(this, "operationValueLabels", {
      generateObject: "Generate JSON",
      generateText: "Agent",
      streamText: "Live Agent",
      embed: "Generate Embedding"
    });
    o(this, "providerValueLabels", {
      openai: "OpenAI",
      anthropic: "Anthropic",
      google: "Google",
      mistral: "Mistral",
      cohere: "Cohere"
    });
    o(this, "getOperationField", () => {
      const e = [...h._def.optionsMap.keys()].map(
        (t) => (t == null ? void 0 : t.toString()) ?? ""
      );
      return {
        fieldName: "operation",
        fieldId: "operation",
        originalPath: this.pathMappings.operation,
        required: !0,
        type: "Enum",
        values: e,
        valuesLabels: e.map((t) => this.operationValueLabels[t])
      };
    });
    o(this, "getProviderField", (e) => {
      const t = [
        ...(e == null ? void 0 : e.shape.model).optionsMap.keys()
      ].map((i) => (i == null ? void 0 : i.toString()) ?? "");
      return {
        fieldName: "provider",
        originalPath: this.pathMappings.provider,
        fieldId: "provider",
        required: !0,
        type: "Enum",
        values: t,
        valuesLabels: t.map((i) => this.providerValueLabels[i])
      };
    });
    o(this, "getModelField", (e) => {
      const t = (e == null ? void 0 : e.shape.model).options;
      return {
        fieldName: "model",
        originalPath: this.pathMappings.model,
        fieldId: "model",
        required: !0,
        type: "Enum",
        values: t
      };
    });
    o(this, "pathMappings", {
      model: ["model", "model"],
      provider: ["model", "provider"],
      operation: ["operation"]
    });
  }
  getOriginalPath(e) {
    return this.pathMappings[e] ?? [
      e
    ];
  }
  getFields(e) {
    const t = this.getFieldValue(e, "operation");
    if (!t)
      return [this.getOperationField()];
    const i = h.optionsMap.get(t), r = this.getFieldValue(e, "provider");
    if (!r)
      return [
        this.getOperationField(),
        this.getProviderField(i)
      ];
    const s = (i == null ? void 0 : i.shape.model).optionsMap.get(r), d = b(i == null ? void 0 : i.shape, [
      "model",
      "provider",
      "operation"
    ]);
    return [
      this.getOperationField(),
      this.getProviderField(i),
      this.getModelField(s),
      ...Object.entries(d).map(([a, n]) => {
        const g = n._def.typeName !== "ZodOptional";
        if (n.description === "jsOnly")
          return {
            type: "jsOnly",
            required: g,
            originalPath: this.getOriginalPath(a),
            fieldId: a,
            fieldName: a,
            label: a
          };
        const u = g ? n._def.typeName : n._def.innerType._def.typeName;
        if (u === "ZodEnum") {
          const m = g ? n.options : n._def.innerType.options;
          return {
            type: "Enum",
            required: g,
            originalPath: this.getOriginalPath(a),
            fieldId: a,
            fieldName: a,
            label: a,
            values: m
          };
        }
        return {
          type: u === "ZodNumber" ? c.Float : c.String,
          required: g,
          originalPath: this.getOriginalPath(a),
          component: L.PlainText,
          fieldId: a,
          fieldName: a
        };
      })
    ];
  }
  getUpdatedState(e, t, i) {
    const r = this.getOriginalPath(t);
    if (t === "provider") {
      const s = this.getFieldValue(e, "operation"), d = this.pathMappings.operation;
      return p(
        r,
        i,
        p(d, s, {})
      );
    }
    return t === "operation" ? p(r, i, {}) : p(r, i, e);
  }
  validate(e) {
    var r;
    const t = h.safeParse(e);
    if (t.success)
      return !0;
    const i = (r = t.error) == null ? void 0 : r.issues.filter((s) => s.code !== "invalid_type").map((s) => ({
      type: "missingField",
      fieldName: s.path.join("."),
      message: s.message
    }));
    return i.length === 0 ? !0 : i;
  }
  getFieldValue(e, t) {
    return f(this.getOriginalPath(t), e);
  }
  getParamsConfigPath(e) {
    return e.flatMap(
      (t, i) => i === 0 ? [t] : ["subParams", t]
    );
  }
  getFieldLogicLanguage(e, t) {
    const i = f(
      this.getParamsConfigPath(this.getOriginalPath(t)),
      e.paramsConfig
    );
    return i ? i.language : this.getFieldLogicLanguageOptions(
      e,
      t
    )[0];
  }
  getFieldLogicLanguageOptions(e, t) {
    const i = this.getFields(e.params);
    return O(
      i,
      t
    ).filter((r) => r !== "json-logic");
  }
  getInitialState() {
    return {};
  }
  getInitialParamsConfig() {
    return {
      messages: {
        type: "logic",
        language: "js"
      },
      schema: {
        type: "logic",
        language: "js"
      },
      tools: {
        type: "logic",
        language: "js"
      }
    };
  }
  getUpdatedParamsConfigState(e, t, i, r) {
    const s = this.getOriginalPath(i), d = this.getParamsConfigPath(s);
    if (r) {
      const a = p(d, r, e);
      return s.slice(0, -1).reduce((n, g, u) => p(
        [
          ...this.getParamsConfigPath(s.slice(0, u + 1)),
          "type"
        ],
        "object",
        n
      ), a);
    }
    return e;
  }
}
export {
  T as GenericAIStepHandler
};
